import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Collapse,
  Grid,
  TablePagination,
} from "@mui/material";
import React, { useState } from "react";
import Heading from "../../../components/Heading";
import TableSearch from "../../../components/common/Table/TableSearch";
import CommonButton from "../../../components/common/Button";
import { FaEye, FaPlus } from "react-icons/fa";
import Input from "../../../components/common/Input";
import { useNavigate } from "react-router-dom";
import { VscFilter } from "react-icons/vsc";
import { salesOrderList } from "../../../Service/salesOrder.service";
import { useEffect } from "react";
import moment from "moment/moment";
import Pagination from "../../../components/common/Table/Pagination";
import { MdDownload } from "react-icons/md";
import { useFormik } from "formik";
import { salesOrderFilterInitialValues } from "../../../helper/initialValues";
import { DealerDropdown } from "../../../Service/dealer.service";
import { TableRowsLoader } from "../../../components/common/Table/TableSkeleton";

const OrderStatusData = [
  { id: 1, name: "Pending" },
  { id: 2, name: "Confirmed" },
  { id: 3, name: "Shipped" },
];

const Shipping = () => {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [shortKey, setShortKey] = useState("name");
  const [salesData, setSalesData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [dealerData, setDealerData] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const formik = useFormik({
    initialValues: salesOrderFilterInitialValues,

    onSubmit: async (values) => {
      console.log(values, "values");
      getSalesList();
    },
  });

  const getDealerDropdownData = async () => {
    let res = await DealerDropdown();
    if (res?.status) {
      setDealerData(res.data);
    } else {
      setDealerData([]);
    }
  };

  const handleFilterClick = () => {
    if (showFilter === true) {
      formik.resetForm();
      setShowFilter(!showFilter);
    } else {
      getDealerDropdownData();
      setShowFilter(!showFilter);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getSalesList = async () => {
    setSalesData(null);

    let query = `?search=${search}&page=${page + 1
      }&perPageSize=${rowsPerPage}&orderBy=${shortKey}&sortFlag=${sortBy}&orderNumber=${formik.values.orderNumber
      }&dealerId=${formik.values.dealerId}&orderDate=${formik.values.orderDate
      }&orderStatus=3`;
    let res = await salesOrderList(query);
    if (res?.status) {
      setSalesData(res?.data);
      setTotalData(res?.total);
      setTotalPages(Math.ceil(res?.total / rowsPerPage));
    } else {
      setSalesData([]);
      setTotalPages(0);
    }
  };

  useEffect(() => {
    getSalesList();
  }, [search, page, rowsPerPage, sortBy, shortKey]);

  return (
    <>
      <Stack gap={2}>
        <Box>
          <Heading head="Shipped Sales Orders" />
        </Box>
        <Box
          sx={{ flexGrow: 1 }}
          display={"flex"}
          justifyContent={"space-between"}
          gap={"10px"}
        >
          <TableSearch
            search={search}
            setSearch={setSearch}
            setPage={setPage}
          />
          <Box display={"flex"} gap={1}>
            <CommonButton
              startIcon={<FaPlus />}
              buttonName="Create"
              onClick={() => navigate("/create-sales-order")}
            />
            <Tooltip title="Filter">
              <CommonButton
                variant="contained"
                buttonName={<VscFilter />}
                onClick={() => handleFilterClick()}
                color="white"
                sx={{ marginTop: "10px" }}
              />
            </Tooltip>
          </Box>
        </Box>
        <Box>
          <Collapse in={showFilter}>
            <Grid
              container
              spacing={0.3}
              className="border_card"
              gap={2}
              p={1.5}
              alignItems={"center"}
            >
              <Grid item xs={4} md={3} lg={2}>
                <Input
                  labelinput="Order No"
                  type="text"
                  {...formik.getFieldProps("orderNumber")}
                />
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <FormControl
                  fullWidth
                  variant="standard"
                  sx={{ marginTop: "-6px" }}
                >
                  <Autocomplete
                    options={dealerData}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      dealerData.find(
                        (data) => data.id === formik.values.dealerId
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        "dealerId",
                        newValue ? newValue.id : ""
                      );
                    }}
                    renderInput={(params) => (
                      <Input
                        {...params}
                        error={
                          formik.touched.dealerId &&
                          Boolean(formik.errors.dealerId)
                        }
                        helperText={
                          formik.touched.dealerId && formik.errors.dealerId
                        }
                        labelinput="Dealer Name"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <Input
                  labelinput="Sale Date"
                  type="date"
                  {...formik.getFieldProps("orderDate")}
                />
              </Grid>
              <Grid item xs={4} md={3} lg={2}>
                <FormControl sx={{ marginTop: "-6px" }} fullWidth>
                  <Autocomplete
                    options={OrderStatusData}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      OrderStatusData.find(
                        (data) => data.id === formik.values.orderStatus
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        "orderStatus",
                        newValue ? newValue.id : ""
                      );
                    }}
                    renderInput={(params) => (
                      <Input
                        {...params}
                        error={
                          formik.touched.orderStatus &&
                          Boolean(formik.errors.orderStatus)
                        }
                        helperText={
                          formik.touched.orderStatus &&
                          formik.errors.orderStatus
                        }
                        labelinput="Order Status"
                      />
                    )}
                  />
                </FormControl>
              </Grid>{" "}
              <Stack gap={1} flexDirection={"row"}>
                <Box>
                  <CommonButton
                    color="primary"
                    buttonName={"Filter"}
                    onClick={formik.handleSubmit}
                  />
                </Box>
                <Box>
                  <CommonButton
                    buttonName={"Clear"}
                    color="white"
                    onClick={() => {
                      formik.resetForm();
                      setShowFilter(false);
                      formik.handleSubmit();
                    }}
                  />
                </Box>
              </Stack>
            </Grid>
          </Collapse>
        </Box>
        <Stack>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Order No</TableCell>
                  <TableCell>Firm Name</TableCell>
                  {/* <TableCell>Shippement Status</TableCell> */}
                  <TableCell>Sale Date</TableCell>
                  {/* <TableCell>Order Status</TableCell> */}
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {salesData === null ? (
                  // Display skeleton loader when data is loading
                  <TableRowsLoader columnsNum={4} />
                ) : salesData.length === 0 ? (
                  // Display "No data available" message when data is empty
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                ) : (
                  salesData?.map((row) => (
                    <TableRow
                      onClick={() =>
                        navigate("/view-sales-order", {
                          state: { id: row?.id },
                        })
                      }
                    >
                      <TableCell> {row?.orderNumber}</TableCell>
                      <TableCell>
                        {row?.companyName} ({row?.dealername})
                      </TableCell>

                      <TableCell>
                        {moment(row?.orderDate).format("DD-MM-YYYY")}
                      </TableCell>
                      {/* <TableCell>
                          <Chip label={row?.orderStatus === 1 ? 'Pending' : row?.orderStatus === 2 ? 'Confirm' : 'Shipped'} style={ row?.orderStatus === 1 ? {backgroundColor: "#FFD600"} : row?.orderStatus === 2 ? {backgroundColor: "#00AD6F"} : {backgroundColor: "#1976D2"}} />
                      </TableCell> */}
                      <TableCell onClick={(e) => e.stopPropagation()}>
                        <Tooltip title="Download Blanket Order PFD">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate("/view-pdf", {
                                state: {
                                  id: row?.id,
                                  pdfName: row?.companyName,
                                },
                              })
                            }
                          >
                            <MdDownload />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate("/view-sales-order", {
                                state: { id: row?.id },
                              })
                            }
                          >
                            <FaEye />
                          </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="Sales Order After Confirmation">
                            <IconButton size="small" onClick={() => navigate("/view-shipping", { state: { id: row?.id } })}>
                              <FaEye />
                            </IconButton>
                          </Tooltip> */}
                      </TableCell>
                    </TableRow>
                  )))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 1 }}>
            {salesData !== null && (
              <Pagination
                totalData={totalData} // Total number of data items
                page={page} // Current page number
                setPage={setPage} // Function to update current page number
                rowsPerPage={rowsPerPage} // Number of rows per page
                setRowsPerPage={setRowsPerPage} // Function to update number of rows per page
              />
            )}
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

export default Shipping;
